<template>
  <CoreDialog
    v-model="isOpened"
    size="sm"
    data-qa="registration-error-modal"
    :title="t(title || 'Ошибка', options)"
  >
    <template
      v-if="message"
      #default
    >
      <div class="text-body-1 text-secondary--text">
        {{ t(message, options) }}
      </div>
    </template>

    <template #actions>
      <v-btn
        data-qa="modal-actions-btn-close"
        color="primary"
        text
        @click="isOpened = false"
      >
        {{ t('Понятно', options) }}
      </v-btn>
    </template>
  </CoreDialog>
</template>

<script lang="ts" setup>
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import I18NextVue from 'i18next'
import { computed, ref, watch } from 'vue'

const { t, language } = I18NextVue
const options = { ns: language }

const props = defineProps<{
  value: boolean
  error: {
    code: string
    message?: string
  }
}>()

type Emits = {
  (_event: 'input', _value: boolean): void
}

const emit = defineEmits<Emits>()

const isOpened = computed({
  get() {
    return props.value
  },
  set(value: boolean) {
    emit('input', value)
  },
})

const title = ref('')
const message = ref('')

const ERROR_MESSAGES: Record<string, {
  title?: string
  message: string
}> = {
  error_conflict_phone: {
    title: t('На этот номер уже зарегистрирован врач', options),
    message: t('Введите другой номер.', options),
  },
  error_conflict_email: {
    title: t('На этот e-mail уже зарегистрирован врач', options),
    message: t('Введите другой e-mail.', options),
  },
  error_foreign_email: {
    title: t('Используйте почту российских компаний', options),
    message: t('Введите другой e-mail.', options),
  },
  error_lpu_email: {
    title: t('Не используйте корпоративный email', options),
    message: t('Введите персональный e-mail, не связанный с клиникой', options),
  },
  validationError: {
    message: t('Не все поля заполнены правильно.', options),
  },
  defaultError: {
    message: t('Произошла ошибка, попробуйте ещё раз.', options),
  },
}

watch(() => props.error, value => {
  if (value.code in ERROR_MESSAGES) {
    const errorData = ERROR_MESSAGES[value.code]

    title.value = errorData?.title ?? t('Ошибка', options)
    message.value = errorData?.message || ''
  } else {
    title.value = t('Ошибка', options)
    message.value = value.message || ''
  }
})
</script>
